import { render, staticRenderFns } from "./TaskSubmit.vue?vue&type=template&id=d610cb0c"
import script from "./TaskSubmit.vue?vue&type=script&lang=js"
export * from "./TaskSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports